import { useCallback, useState } from 'react';

type ErrorMap = Record<string, string>;

export const useBackendErrors = (initialErrors: ErrorMap = {}) => {
  const [backendErrors, setBackendErrors] = useState<ErrorMap>(initialErrors);

  const setMappedErrors = useCallback((rawError: unknown, mapper: (e: unknown) => ErrorMap) => {
    setBackendErrors(mapper(rawError));
  }, []);

  const clearBackendErrors = useCallback(() => {
    setBackendErrors({});
  }, []);

  return {
    backendErrors,
    setBackendErrors,
    setMappedErrors,
    clearBackendErrors,
  };
};
